import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search',
    standalone: false,
})
export class SearchPipe implements PipeTransform {
    public transform(value, keys: string, term: string) {
        if (!term) {
            return value;
        }

        if (keys) {
            return (value || []).filter(item =>
                keys.split(',').some(key => ('' + item[key]).toLowerCase().indexOf(term.toLowerCase()) !== -1)
            );
        } else {
            return (value || []).filter(item => item.toLowerCase().indexOf(term.toLowerCase()) !== -1);
        }
    }
}
